import { styledComponent } from '@hermes/web-components'

export const MainContainer = styledComponent('div')`
  display: flex;
  flex-direction: column;
  gap: 17px;
  width: 100%;
  `

export const HorizontalLine = styledComponent('div')`
  height: 1px;
  width: 100%;
  background-color: #D5DEF9;
  `

export const SelectContainer = styledComponent('div')`
  display: flex;
  gap: 30px;
  @media (max-width: 768px) {
    overflow-x: auto;
    padding-bottom: 10px;
    margin-bottom: -10px;
  }
  `

export const DropDownContainer = styledComponent('div')<{ isVisible: boolean }>`
  display: grid;
  gap: 15px;
  grid-template-columns: repeat(4, 1fr);
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  transition: opacity 0.2s ease-in-out;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`
